import React from "react";
import LegalLayout from "../components/LegalLayout";

const Section = ({ title, children }) => (
  <div data-testid={`privacy-section-${title.toLowerCase().replace(/\s/g, "-")}`}>
    <h2 className="font-heading text-white text-2xl md:text-3xl uppercase tracking-[0.05em] mb-4">
      {title}
    </h2>
    <div className="space-y-3 text-white/85">{children}</div>
  </div>
);

const PrivacyPolicy = () => {
  return (
    <LegalLayout
      eyebrow="Legal — RGPD"
      title="Política de Privacidade"
      testId="privacy-policy-page"
    >
      <p>
        A presente Política de Privacidade descreve a forma como os teus dados pessoais são
        recolhidos, utilizados e protegidos no website <strong className="text-white">Miguel Faria Photography</strong>,
        em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD —{" "}
        Regulamento (UE) 2016/679) e a legislação portuguesa aplicável.
      </p>

      <Section title="Responsável pelo Tratamento dos Dados">
        <p>
          <strong className="text-white">Miguel Faria Photography</strong>
          <br />
          Portugal
          <br />
          Contacto:{" "}
          <a
            href="https://www.instagram.com/miguelfaria.photo/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#c0392b] hover:text-white underline underline-offset-4 transition-colors"
          >
            @miguelfaria.photo
          </a>{" "}
          ou através do formulário de contacto disponível no site.
        </p>
      </Section>

      <Section title="Dados Recolhidos">
        <p>Através do formulário de contacto, recolhemos apenas os dados estritamente necessários:</p>
        <ul className="list-none space-y-2 pl-0">
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span>Nome</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span>Endereço de email</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span>Tipo de projeto pretendido</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span>Mensagem / conteúdo do pedido</span></li>
        </ul>
      </Section>

      <Section title="Finalidade do Tratamento">
        <p>
          Os dados recolhidos destinam-se exclusivamente a:
        </p>
        <ul className="list-none space-y-2">
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span>Responder a pedidos de orçamento, informações e marcações</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span>Estabelecer comunicação relativa ao projeto solicitado</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span>Cumprir obrigações legais ou contratuais decorrentes do serviço</span></li>
        </ul>
        <p>
          Os dados <strong className="text-white">não são utilizados</strong> para fins de marketing direto,
          partilha com terceiros ou criação de perfis automatizados.
        </p>
      </Section>

      <Section title="Fundamento Legal">
        <p>
          O tratamento dos dados pessoais baseia-se no <strong className="text-white">consentimento expresso</strong> do
          titular (artigo 6.º, n.º 1, alínea a) do RGPD), prestado ao submeter o formulário,
          bem como em interesses legítimos do responsável pelo tratamento para responder a
          pedidos comerciais.
        </p>
      </Section>

      <Section title="Conservação dos Dados">
        <p>
          Os dados pessoais são conservados pelo período de{" "}
          <strong className="text-white">2 (dois) anos</strong> a contar da data da última comunicação,
          após o qual são eliminados de forma segura. Em caso de contratação de serviços, alguns
          dados poderão ser conservados por períodos superiores no estrito cumprimento de obrigações
          legais (ex.: fiscais).
        </p>
      </Section>

      <Section title="Direitos do Utilizador">
        <p>Nos termos do RGPD, podes a qualquer momento exercer os seguintes direitos:</p>
        <ul className="list-none space-y-2">
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Acesso</strong>: saber que dados detemos sobre ti</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Retificação</strong>: corrigir dados imprecisos ou desatualizados</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Eliminação</strong> ("direito ao esquecimento")</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Limitação</strong> do tratamento</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Portabilidade</strong> dos dados</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Oposição</strong> ao tratamento</span></li>
          <li className="flex gap-3"><span className="text-[#c0392b]">—</span><span><strong className="text-white">Retirada do consentimento</strong> a qualquer momento</span></li>
        </ul>
        <p>
          Para exercer qualquer um destes direitos, contacta-nos através do formulário do site
          ou via Instagram{" "}
          <a
            href="https://www.instagram.com/miguelfaria.photo/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#c0392b] hover:text-white underline underline-offset-4 transition-colors"
          >
            @miguelfaria.photo
          </a>.
          Tens ainda o direito de apresentar reclamação à autoridade de controlo competente
          (Comissão Nacional de Proteção de Dados — CNPD, www.cnpd.pt).
        </p>
      </Section>

      <Section title="Segurança">
        <p>
          Adotamos medidas técnicas e organizativas adequadas para proteger os dados pessoais
          contra acesso não autorizado, perda acidental, alteração ou divulgação indevida,
          incluindo armazenamento em base de dados protegida e comunicação sob HTTPS.
        </p>
      </Section>

      <Section title="Cookies">
        <p>
          Este site utiliza cookies essenciais ao seu funcionamento e cookies analíticos
          opcionais. Consulta a nossa{" "}
          <a
            href="/politica-cookies"
            className="text-[#c0392b] hover:text-white underline underline-offset-4 transition-colors"
            data-testid="link-to-cookies"
          >
            Política de Cookies
          </a>{" "}
          para mais informações.
        </p>
      </Section>

      <Section title="Alterações à Política">
        <p>
          A presente Política poderá ser atualizada periodicamente. A data da última atualização
          encontra-se indicada no final desta página.
        </p>
      </Section>
    </LegalLayout>
  );
};

export default PrivacyPolicy;
